import React from 'react'
import { Slot } from 'radix-ui'

import { cn } from '@/shared/lib/utils'

function DeltaValue({
	value = 0,
	className,
	children,
	opposite,
	asChild,
	...props
}: React.ComponentProps<'span'> & {
	asChild?: boolean
	opposite?: boolean
	value: any
}) {
	const Comp = asChild ? Slot.Root : 'span'

	return (
		<Comp
			{...props}
			className={cn(
				{
					'text-success': opposite ? value < 0 : value > 0,
					'text-destructive': opposite ? value > 0 : value < 0,
				},
				className
			)}
		>
			{children}
		</Comp>
	)
}
DeltaValue.displayName = 'DeltaValue'
export { DeltaValue }
